import { b } from "@/b";
import { OutputOf } from "@gqlb/core";
import React from "react";

export const CURRENCY_FRAGMENT = b.fragment(
  "CurrencyRenderer",
  "Currency",
  (b) => [b.formatted(), b.value()]
);

export const CurrencyRenderer: React.FC<{
  data: OutputOf<typeof CURRENCY_FRAGMENT>;
  freeStyle?: "null" | "free" | "show" | React.ReactNode;
  prefix?: string;
  suffix?: string;
}> = ({ data, freeStyle = "show", prefix = "", suffix = "" }) => {
  if (data.value === 0 && freeStyle === "null") return null;
  if (data.value === 0 && freeStyle === "free")
    return (
      <>
        {prefix}Free{suffix}
      </>
    );
  return (
    <>
      {prefix}
      {data.formatted}
      {suffix}
    </>
  );
};
